import Vue from 'vue'
import VueRouter from "vue-router";

import { store } from './store';

const DefaultLayout = () => import('@/layouts/' + process.env.VUE_APP_DEFAULT_LAYOUT);

const Login = () => import("@/pages/Login");
const HostPage = () => import("@/pages/HostPage");
const GuestPage = () => import("@/pages/GuestPage");
const AdminPage = () => import("@/pages/AdminPage");
const RecordingsPage = () => import("@/pages/RecordingsPage");
const SessionsPage = () => import("@/pages/SessionsPage");
const MonitoringPage = () => import("@/pages/MonitoringPage");

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            async beforeEnter(to, from, next) {
                // this catches the old style ?i=[INVITE_ID] urls
                if (to.query.i) {
                    return next(`/i/${to.query.i}`);
                }

                if (store.getters['auth/isHost']) {
                    return next('/host');
                }

                next('/login');
            }
        },
        {
            name: 'login',
            path: '/login',
            component: Login,
            meta: {
                title: 'PreRec - Login',
                layout: DefaultLayout,
            }
        },
        {
            name: 'host',
            path: '/host/:hostNumber?',
            component: HostPage,
            beforeEnter(to, from, next) {
                let hostNumber = +to.params.hostNumber || 1;
                store.commit('HOST_NUMBER', hostNumber);
                next();
            },
            meta: {
                title: 'PreRec - Host',
                layout: DefaultLayout,
                validateToken: true,
                requiresHost: true
            }
        },
        {
            name: 'invite',
            path: '/i/:inviteId',
            component: GuestPage,
            meta: {
                title: 'PreRec - Guest',
                layout: DefaultLayout,
            },
            async beforeEnter(to, from, next) {
                try {
                    await store.dispatch('auth/validateInvite', to.params.inviteId);
                    return next();  // maybe we need an Invalid Invite page
                }
                catch (err) {
                    console.error(err.message);
                }

                next('/login');
            }
        },
        {
            name: 'admin',
            path: '/admin',
            component: AdminPage,
            meta: {
                title: 'PreRec - Admin',
                layout: DefaultLayout,
                validateToken: true,
                requiresAdmin: true
            }
        },
        {
            name: 'recordings',
            path: '/recordings/:sessionId',
            props: true,
            component: RecordingsPage,
            meta: {
                title: 'PreRec - Recordings',
                layout: DefaultLayout,
                validateToken: true,
                requiresHost: true
            }
        },
        {
            name: 'sessions',
            path: '/sessions/:userId',
            props: true,
            component: SessionsPage,
            meta: {
                title: 'PreRec - Sessions',
                layout: DefaultLayout,
                validateToken: true,
                requiresAdmin: true
            }
        },
        {
            name: 'monitoring',
            path: '/monitor',
            component: MonitoringPage,
            meta: {
                title: 'PreRec - Monitoring',
                validateToken: true,
                requiresAdmin: true
            }
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    // check authorised
    let allowNext = true;

    if (to.meta.validateToken) {
        try {
            await store.dispatch('auth/validateToken');
        }
        catch (err) {
            console.error(err.message);
            allowNext = false;
        }
    }

    if (to.meta.requiresAdmin && !store.getters['auth/isAdmin']) allowNext = false;
    if (to.meta.requiresHost && !store.getters['auth/isHost']) allowNext = false;

    if (!allowNext) {
        next({
            path: '/login',
            query: { nextPage: to.fullPath }
        });
    }
    else {
        next();
    }
});

export default router;